import { render, staticRenderFns } from "./ArticleBodyFind.vue?vue&type=template&id=5d15b033&scoped=true&"
import script from "./ArticleBodyFind.vue?vue&type=script&lang=js&"
export * from "./ArticleBodyFind.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBodyFind.vue?vue&type=style&index=0&id=5d15b033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15b033",
  null
  
)

export default component.exports